import { IconBadgeFail, IconBadgeSuccess } from 'featherico';
import PropTypes from 'prop-types';

function IconValidation({ isValid }) {
    return isValid ? <IconBadgeSuccess /> : <IconBadgeFail />;
}

IconValidation.propTypes = {
    isValid: PropTypes.bool,
};

export default IconValidation;
